import { Text } from '@innovationdepartment/proxima-ui';
import SectionLayout from 'ui/SectionLayout';
import type { WorkflowExecutionRow } from '../BrandWorkflows.types';
import WorkflowExecutionList from '../WorkflowExecutionList';
import { BackLink } from './WorkflowRunHistory.styles';

type WorkflowRunHistoryViewProps = {
  workflowType: string;
  brandName: string;
  workflowsPath: string;
  rows: WorkflowExecutionRow[];
  loading: boolean;
  error: string | null;
};

/* No `actions` on the shared list here: a run-history link would be circular, and only
   the latest run may be retried — both live on the Workflows page */
const WorkflowRunHistoryView = ({
  workflowType,
  brandName,
  workflowsPath,
  rows,
  loading,
  error
}: WorkflowRunHistoryViewProps) => (
  <SectionLayout
    title={brandName ? `${workflowType} · ${brandName}` : workflowType}
    headerContent={<BackLink to={workflowsPath}>← All workflows</BackLink>}
  >
    {error ? (
      <Text variant="body2" color="red60">
        Failed to load run history: {error}
      </Text>
    ) : (
      <WorkflowExecutionList
        rows={rows}
        loading={loading}
        emptyText="This workflow hasn't run for this brand yet."
        showRetry={false}
        showRunHistoryLink={false}
      />
    )}
  </SectionLayout>
);

export default WorkflowRunHistoryView;
